import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--score" icon='score'>{ children ? children : '0' }</Button>
}